import {
  postCall,
  getCall,
  HeadersInterface,
  BodyParamsInterface,
} from "./api";

const BASE_URL = "v1/legit";

export const getLegitChecks = async (item_id: number) => {
  let url = BASE_URL;
  let headers: HeadersInterface | undefined;

  let response = await getCall(url, headers, "item_id=" + item_id);

  return response;
};

export const postLegitCheck = async (
  item_id: number,
  comment: string,
  is_legit: boolean,
) => {
  let url = BASE_URL;
  let body: BodyParamsInterface = [
    { name: "item_id", value: item_id },
    { name: "comment", value: comment },
    { name: "is_legit", value: is_legit },
  ];
  let headers: HeadersInterface | undefined;

  let response = await postCall(url, headers, undefined, body);

  return response;
};
